import React from 'react';
import PropTypes from 'prop-types';

// Components
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';

// Utils
import { getFileOpenUrl } from 'utils/google-drive-utils';


export default function GoogleDriveLink({ fileId, children, title, ...props }) {
  return (
    <a href={getFileOpenUrl(fileId)} target="_blank" {...props}>
      <Tooltip title={title || 'View in Google Drive'} className="inline-block">
        <SVG src="svg/google-drive.svg" className="google-drive" />
      </Tooltip>
      {children}
    </a>
  );
}

GoogleDriveLink.propTypes = {
  fileId: PropTypes.string,
  children: PropTypes.any,
  title: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/widgets/icons/link-icons/google-drive-link.js